import angular from "angular";
import lessonsModalComponent from "./lessons-modal.component";

angular.module('lessonsModal', [lessonsModalComponent])


export default 'lessonsModal';


// WEBPACK FOOTER //
// ./resources/assets/modules/lessons-modal/lessons-modal.module.js